import { IOption } from "@components/formik/SelectUpdated/SelectUpdated";

export const mapToOption = (value: string, label: string): IOption<string> => ({
  value,
  label,
});
